import { AfterViewInit, Component, OnInit, Renderer2 } from "@angular/core";
import { UploadService } from "../../services/uploadService";
import { Guid } from "../../common/helpers/guidHelper";
import { ActivatedRoute } from "@angular/router";


@Component({
    selector: "order-export",
    templateUrl: "order-export.component.html",
    moduleId: module.id.toString()
})
export class OrderExportComponent implements AfterViewInit, OnInit{

    public constructor(private route: ActivatedRoute, private uploadService: UploadService, private renderer: Renderer2) {

    }

    public ngOnInit(): void{
        this.route.queryParams.subscribe(param => {
            let dateFrom = param['datefrom'];
            let dateTo =  param['dateto'];

            let fileName = `order_export_${Guid.newGuid()}.csv`;
            this.uploadService.exportOrders(fileName, dateFrom, dateTo).then(()=> {
                setTimeout(_ => {
                    window.close();
                }, 1000);
            });
        })
    }

    public ngAfterViewInit(): void {
        let spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
    }
}


// WEBPACK FOOTER //
// ./app/components/export/order-export.component.ts